
import { Router, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Component, OnInit, AfterViewInit, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
// import { trigger, state, style, transition, animate } from '@angular/animations';
import { AccountService } from '../../../services/account.service';
import { AuthService } from '../../../services/auth/auth.service';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { LoginViewModel } from '../../../models/login-view-model';
import { AuthResponse } from '../../../models/auth-response';
// import { PushNotificationsService } from 'ng-push';
// import { NgProgress } from '@ngx-progressbar/core';
import { ConfirmationPageSuccessComponent } from '../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { BusyIndicatorComponent } from '../../../shared-components/busy-indicator/busy-indicator.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalComponent } from '../../../shared-components/modal/modal.component';
import { DataService } from '../../../services/data.service';
import { ContractService } from '../../../services/contract.service';
import { LoginResult } from '../../../models/LoginResult';
import { PARAMETERS } from '@angular/core/src/util/decorators';

@Component({
  selector: 'app-transient',
  templateUrl: './transient.component.html',
  styleUrls: ['./transient.component.scss']
})
export class TransientComponent implements OnInit {
  alive =  true;
  showFailConfirmation = false;
  showSuccessConfirmation = false;
  token: string;
  userguid: string;
  loginFailDescription: string;


  constructor(private _accountSerivce: AccountService,
    private _authService: AuthService,
    private _contractService: ContractService,
    private _router: Router,
    private _route: ActivatedRoute,
    // private _pushNotice: PushNotificationsService,
    // public progress: NgProgress,
    private _spinner: NgxSpinnerService,
    private _dataService: DataService,
  ) {
    //  _pushNotice.requestPermission();


    this._route.queryParams
      .takeWhile(() => this.alive)
      .subscribe(params => {
        this.showFailConfirmation = false;
        this.showSuccessConfirmation = false;
       if (params['userguid']) {
          this.userguid = params['userguid'];
       }
       if (params['token']) {
          this.token = params['token'];
        }
      });
      this.transient();
  }

  ngOnInit() {

  }
  transient() {

    // this._authService.authenticateTransientUser(this.userguid,
    //   this.token ,
    //   this._dataService.userDisplayInfo.bearerToken)
    //  .subscribe(
    //     data => {
    //       console.log(data);
    //       alert(data);
    //     },
    //     error => {
    //      // alert('error' + error);
    //     console.log(error);
    //     }

    // );
  }





}



// WEBPACK FOOTER //
// ./src/app/pages/account/transient/transient.component.ts